<template>
  <date-time-field
    :output-format="localFormat(trans, aspect)"
    :input-format="'mm:ss'"
    :settings="settings"
    :value="value"
  ></date-time-field>
</template>

<script>
import DateTimeField from '@kanrisha/components/Elements/Display/DateTimeField';

export default {
  components: {
    DateTimeField,
  },
  props: {
    value: { type: String, default: '' },
    outputFormat: { type: String, default: () => 'mm:ss' },
    settings: { type: Object, default: () => ({ iconClass: 'bi bi-clock' }) },
  },
  setup(props) {
    const localFormat = (trans, aspect) => {
      if (!props.outputFormat) {
        return 'mm:ss';
      }

      return props.outputFormat.replace('U', '[' + trans(`aspects.${aspect}.common.time-suffix`) + ']');
    };

    return {
      localFormat,
    };
  },
};
</script>
